var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Link } from "core/components/Link";
import { easing, mq } from "core/styles/snippets";
import React from "react";
import styled from "styled-components";
var VTMLogoBase = function (_a) {
    var src = _a.src, alt = _a.alt, className = _a.className, props = __rest(_a, ["src", "alt", "className"]);
    return (React.createElement(StyledLink, { onClick: props.onClick, url: "/", className: className, "data-component": props["data-component"], "data-gtm": props["data-gtm"] },
        React.createElement(Logo, { src: src, alt: alt })));
};
export var VTMLogo = function (props) { return (React.createElement(VTMLogoBase, __assign({ src: "/images/logos/vtm-2024.svg", alt: "VTM Logo" }, props))); };
export var VTMLogoOrange = function (props) { return (React.createElement(VTMLogoBase, __assign({ src: "/images/logos/vtm-orange.svg", alt: "VTM Logo" }, props))); };
export var VTMLogoMulticolor = function (props) { return (React.createElement(VTMLogoBase, __assign({ src: "/images/logos/vtm-multicolor.webp", alt: "VTM Logo" }, props))); };
var StyledLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: all 0.25s ", ";\n\n  ", " {\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n"], ["\n  transition: all 0.25s ", ";\n\n  ", " {\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n"])), easing.expo.out, mq.hover("hover"));
var Logo = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-height: 100%;\n"], ["\n  max-height: 100%;\n"])));
var templateObject_1, templateObject_2;
